export enum BaseCountry {
  AU = 'asaleocare-au',
  NZ = 'asaleocare-nz'
}
